var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('the-layout-portal', [_vm.isLoading ? _c('v-container', [_c('v-skeleton-loader', {
    attrs: {
      "type": "heading, actions, heading, table-row, list-item-two-line@4"
    }
  })], 1) : _vm.partner ? _c('v-container', {
    attrs: {
      "fluid": ""
    }
  }, [_c('m-header', {
    attrs: {
      "title": _vm.title,
      "chips": _vm.chips,
      "breadCrumbs": _vm.breadCrumbs,
      "actions": _vm.actions
    }
  }), _c('paginated-table', {
    ref: "reportTable",
    attrs: {
      "store": _vm.store,
      "headers": _vm.headers,
      "baseQuery": {
        partnerId: _vm.partnerId
      },
      "predefinedFilter": _vm.predefinedFilter,
      "quickFilters": _vm.quickFilters,
      "selectedItems": _vm.selectedItems,
      "showSelect": true
    },
    on: {
      "update:selectedItems": function updateSelectedItems($event) {
        _vm.selectedItems = $event;
      },
      "update:selected-items": function updateSelectedItems($event) {
        _vm.selectedItems = $event;
      },
      "click:row": _vm.setSelectedItem
    },
    scopedSlots: _vm._u([{
      key: "item.title",
      fn: function fn(_ref) {
        var item = _ref.item;
        return [_c('div', [_c('div', {
          staticClass: "font-weight-bold"
        }, [_vm._v(" " + _vm._s(item.title) + " ")]), item.position ? _c('div', _vm._l(Object.values(_vm.ZoneTypeEnum), function (type) {
          return _c('span', {
            key: item.id + type
          }, [item.position.getHitZonesByType(type).length ? _c('span', [_vm._v(" " + _vm._s(_vm.$t("enums.ZoneTypeEnum.".concat(type))) + ": "), _c('b', [_vm._v(" " + _vm._s(item.position.getHitZonesByType(type).map(function (z) {
            return z.name;
          }).join(", ")) + " ")])]) : _vm._e()]);
        }), 0) : _vm._e()])];
      }
    }, {
      key: "selectActions",
      fn: function fn() {
        return [_c('span', {
          staticClass: "caption"
        }, [_vm._v(_vm._s(_vm.selectedItems.length) + " " + _vm._s(_vm.$t("selected")))]), _c('v-icon', {
          staticClass: "mx-2",
          attrs: {
            "small": ""
          }
        }, [_vm._v("mdi-arrow-right")]), _c('v-btn', {
          attrs: {
            "small": "",
            "outline": "",
            "text": "",
            "loading": _vm.isLoadingUpdate
          },
          on: {
            "click": _vm.completedSelected
          }
        }, [_c('v-icon', [_vm._v("mdi-check-all")]), _vm._v(" " + _vm._s(_vm.$t("acknowledge")))], 1)];
      },
      proxy: true
    }, {
      key: "item.timestamp.created",
      fn: function fn(_ref2) {
        var item = _ref2.item;
        return [_vm._v(" " + _vm._s(_vm._f("simpleDoubleDigitDate")(item.timestamp.created)) + " ")];
      }
    }, {
      key: "item.repair.startDate",
      fn: function fn(_ref3) {
        var item = _ref3.item;
        return [item.repair ? _c('due-date-chip', {
          attrs: {
            "ticket": {
              due: item.repair.startDate
            }
          }
        }) : _vm._e()];
      }
    }, {
      key: "item.repair.endDate",
      fn: function fn(_ref4) {
        var item = _ref4.item;
        return [item.repair ? _c('due-date-chip', {
          attrs: {
            "ticket": {
              due: item.repair.endDate,
              state: item.isFixed || item.repair.status === _vm.RepairStatusEnum.FINISHED || item.repair.status === _vm.RepairStatusEnum.FICTITIOUS ? '' : 'open'
            }
          }
        }) : _vm._e()];
      }
    }, {
      key: "item.progressStatus",
      fn: function fn(_ref5) {
        var item = _ref5.item;
        return [_c('v-chip', {
          attrs: {
            "small": "",
            "color": _vm.color(item.progressStatus),
            "elevation": 0,
            "dark": ""
          }
        }, [_vm._v(" " + _vm._s(_vm.$t("enums.ProgressStatusEnum.".concat(item.progressStatus))) + " ")])];
      }
    }, {
      key: "item.coverageType",
      fn: function fn(_ref6) {
        var item = _ref6.item;
        return [item.coverageType ? _c('span', [_vm._v(" " + _vm._s(_vm.$t("enums.CoverageTypeEnum.".concat(item.coverageType))) + " ")]) : _vm._e()];
      }
    }, {
      key: "item.damageType",
      fn: function fn(_ref7) {
        var item = _ref7.item;
        return [item.damageType ? _c('span', [_vm._v(" " + _vm._s(_vm.$t("enums.DamageTypeEnum.".concat(item.damageType))) + " ")]) : _vm._e()];
      }
    }, {
      key: "item.isFixed",
      fn: function fn(_ref8) {
        var item = _ref8.item;
        return [_vm._v(" " + _vm._s(item.isFixed ? _vm.$t("yes") : _vm.$t("no")) + " ")];
      }
    }, {
      key: "item.towing.status",
      fn: function fn(_ref9) {
        var item = _ref9.item;
        return [_vm._v(" " + _vm._s(item.towing.length > 0 ? _vm.$t("yes") : _vm.$t("no")) + " ")];
      }
    }, {
      key: "item.repair.status",
      fn: function fn(_ref10) {
        var item = _ref10.item;
        return [item.repair ? _c('span', [_vm._v(" " + _vm._s(_vm.$t("enums.RepairStatusEnum.".concat(item.repair.status))) + " ")]) : _vm._e()];
      }
    }, {
      key: "item.customerName",
      fn: function fn(_ref11) {
        var item = _ref11.item;
        return [item.customerName ? _c('span', [_vm._v(_vm._s(item.customerName))]) : _vm._e()];
      }
    }, {
      key: "item.accidentDetails.date",
      fn: function fn(_ref12) {
        var item = _ref12.item;
        return [item.accidentDetails && item.accidentDetails.date ? _c('span', [_vm._v(" " + _vm._s(_vm._f("simpleDoubleDigitDate")(item.accidentDetails.date)) + " ")]) : _c('span', [_vm._v("-")])];
      }
    }, {
      key: "item.assignees",
      fn: function fn(_ref13) {
        var item = _ref13.item;
        return [_c('assignee-preview', {
          attrs: {
            "value": item.assignees,
            "amount": 3,
            "partnerId": _vm.partnerId
          }
        })];
      }
    }, {
      key: "item.vehicleId",
      fn: function fn(_ref14) {
        var item = _ref14.item;
        return [item && item.vehicleId ? _c('div', _vm._l([_vm.vehicleCache.get(item.vehicleId)], function (entry, idx) {
          return _c('div', {
            key: "".concat(item.id, "-vehicle-").concat(idx)
          }, [entry.isLoading ? _c('v-skeleton-loader', {
            attrs: {
              "type": "title"
            }
          }) : entry.data ? _c('refs-vehicle', {
            attrs: {
              "item": entry.data,
              "small": true
            },
            on: {
              "openDetail": function openDetail($event) {
                entry.data.goTo(_vm.$router).detail();
              }
            }
          }) : _c('div', [_vm._v("-")])], 1);
        }), 0) : _c('div', [_vm._v("-")])];
      }
    }, {
      key: "item.handover",
      fn: function fn(_ref15) {
        var item = _ref15.item;
        return [item && item.handover && item.handover.handoverId ? _c('div', _vm._l([_vm.handoverCache.get(item.handover.handoverId)], function (entry, idx) {
          return _c('div', {
            key: "".concat(item.id, "-handover-").concat(idx)
          }, [entry.isLoading ? _c('v-skeleton-loader', {
            attrs: {
              "type": "title"
            }
          }) : entry.data ? _c('refs-handover', {
            attrs: {
              "item": entry.data,
              "small": true
            },
            on: {
              "openDetail": function openDetail($event) {
                entry.data.goTo(_vm.$router).detail();
              }
            }
          }) : _c('div', [_vm._v("-")])], 1);
        }), 0) : _c('span', [_vm._v("-")])];
      }
    }, {
      key: "item.handover.foundInInspection",
      fn: function fn(_ref16) {
        var item = _ref16.item;
        return [item && item.handover && item.handover.handoverId && item.handover.foundInInspection ? _c('div', _vm._l([_vm.handoverCache.get(item.handover.handoverId)], function (entry, idx) {
          return _c('div', {
            key: "".concat(item.id, "-inspection-").concat(idx)
          }, [entry.isLoading ? _c('v-skeleton-loader', {
            attrs: {
              "type": "text"
            }
          }) : entry.data ? _c('refs-inspection', {
            attrs: {
              "item": entry.data.inspections.find(function (i) {
                return i.id === item.handover.foundInInspection;
              }),
              "small": true
            },
            on: {
              "openDetail": function openDetail($event) {
                var _entry$data$inspectio;

                (_entry$data$inspectio = entry.data.inspections.find(function (i) {
                  return i.id === item.handover.foundInInspection;
                })) === null || _entry$data$inspectio === void 0 ? void 0 : _entry$data$inspectio.goTo(_vm.$router).detail();
              }
            }
          }) : _c('div', [_vm._v("-")])], 1);
        }), 0) : _c('span', [_vm._v("-")])];
      }
    }, {
      key: "item.damages",
      fn: function fn(_ref17) {
        var item = _ref17.item;
        return [item.damage ? _c('span', [_vm._v(" " + _vm._s(item.damage.map(function (damage) {
          return _vm.$t("components.partner.PartnerReportDetail.PartnerReportUpdateReportDialog.report.damages.".concat(damage));
        }).join(", ")) + " ")]) : _vm._e(), item.position ? _c('span', [_vm._v(" " + _vm._s(item.position.blueprint.name) + " ")]) : _vm._e()];
      }
    }, {
      key: "item.invoiceOutboundAggregation.totals",
      fn: function fn(_ref18) {
        var item = _ref18.item;
        return [item.invoiceOutboundAggregation && item.invoiceOutboundAggregation.totals && item.invoiceOutboundAggregation.totals.length > 0 ? _c('div', _vm._l(item.invoiceOutboundAggregation.totals, function (total) {
          return _c('div', {
            key: "invoice_aggregation_".concat(item.id, "_").concat(total.currency)
          }, [_vm._v(" " + _vm._s(_vm.formatCurrency(total.subtotal, total.currency)) + " ")]);
        }), 0) : _c('span', {
          staticStyle: {
            "text-align": "right"
          }
        }, [_vm._v("-")])];
      }
    }, {
      key: "item.invoiceInboundAggregation.totals",
      fn: function fn(_ref19) {
        var item = _ref19.item;
        return [item.invoiceInboundAggregation && item.invoiceInboundAggregation.totals && item.invoiceInboundAggregation.totals.length > 0 ? _c('div', _vm._l(item.invoiceInboundAggregation.totals, function (total) {
          return _c('div', {
            key: "invoice_aggregation_".concat(item.id, "_").concat(total.currency)
          }, [_vm._v(" " + _vm._s(_vm.formatCurrency(total.subtotal, total.currency)) + " ")]);
        }), 0) : _c('span', {
          staticStyle: {
            "text-align": "right"
          }
        }, [_vm._v("-")])];
      }
    }, {
      key: "item.invoiceAggregation.totals",
      fn: function fn(_ref20) {
        var item = _ref20.item;
        return [item.invoiceAggregation && item.invoiceAggregation.totals && item.invoiceAggregation.totals.length > 0 ? _c('div', _vm._l(item.invoiceAggregation.totals, function (total) {
          return _c('div', {
            key: "invoice_aggregation_".concat(item.id, "_").concat(total.currency),
            class: total.subtotal < 0 ? 'red--text' : ''
          }, [_vm._v(" " + _vm._s(_vm.formatCurrency(total.subtotal, total.currency)) + " ")]);
        }), 0) : _c('span', {
          staticStyle: {
            "text-align": "right"
          }
        }, [_vm._v("-")])];
      }
    }])
  })], 1) : _vm._e(), _vm.showSideCard ? _c('partner-report-detail-side-card', {
    attrs: {
      "loading": _vm.isLoadingReport
    },
    on: {
      "close": _vm.closeSideCard
    }
  }) : _vm._e()], 1);
}
var staticRenderFns = []

export { render, staticRenderFns }